import { UiSection } from '../enums';
import { ISearchResultsLocaleLookupKeys, ISimpleSearchLocaleLookupKeys, IUploadLocaleLookupKeys } from './interfaces';
import { IHeaderLocaleLookupKeys } from './interfaces/header';

export interface ILookupKeyProvider {
  simpleSearch: ISimpleSearchLocaleLookupKeys,
  searchResults: ISearchResultsLocaleLookupKeys,
  upload: IUploadLocaleLookupKeys,
  header: IHeaderLocaleLookupKeys
}

const creator = (...keys: string[]): string => {
  if (keys && keys.length > 0) {
    return keys.reduce((prev, curr) => `${prev}.${curr}`);
  }

  throw new Error('No locale keys have been provided to be able to produce a lookup key');
};

// TODO: Probably should create consts for the recurring keys to facilitate easier changes if needed
// not sure if a "Provider" is the best way
export const LocaleKeyTree: ILookupKeyProvider = {
  simpleSearch: {
    searchInputPlaceholder: creator(UiSection.SimpleSearch, 'SearchInput', 'Placeholder'),
    searchButtonText: creator(UiSection.SimpleSearch, 'SearchButton', 'Text'),
  },
  searchResults: {
    searchButtonText: creator(UiSection.SearchResults, 'SearchButton', 'Text'),
    searchInputPlaceholder: creator(UiSection.SearchResults, 'QueryInput', 'Placeholder'),
    searchDateFromInputPlaceholder: creator(UiSection.SearchResults, 'DateFromInput', 'Placeholder'),
    searchDateToInputPlaceholder: creator(UiSection.SearchResults, 'DateToInput', 'Placeholder'),
    vaultButtonText: creator(UiSection.SearchResults, 'VaultButton', 'Text'),
    socialButtonText: creator(UiSection.SearchResults, 'SocialButton', 'Text'),
    clearFilter: creator(UiSection.SearchResults, 'ResultsTable', 'ClearFilter'),
    applyFilter: creator(UiSection.SearchResults, 'ResultsTable', 'ApplyFilter'),
    paginationKeys: {
      total: creator(UiSection.SearchResults, 'ResultsTable', 'Pagination', 'Total'),
      size: creator(UiSection.SearchResults, 'ResultsTable', 'Pagination', 'Size'),
      limit: creator(UiSection.SearchResults, 'ResultsTable', 'Pagination', 'Limit'),
    },
    resultsTableKeys: {
      headerID: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'ID'),
      headerDate: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Date'),
      headerTitle: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Title'),
      headerOrgTagIds: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Tags'),
      headerSport: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Sport'),
      headerAwayTeam: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'AwayTeam'),
      headerHomeTeam: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'HomeTeam'),
      headerVideoType: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'VideoType'),
      headerThumbNailUrl: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'ThumbNailUrl'),
      headerCreatedDate: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'createdDate'),
      headerOwner: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Owner'),
      headerQualifier: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'Qualifier'),
      headerGameNumber: creator(UiSection.SearchResults, 'ResultsTable', 'Header', 'GameNumber'),
    },
  },
  upload: {
    uploadCard: {
      title: creator(UiSection.Upload, 'UploadCard', 'Title'),
      getTokenButton: creator(UiSection.Upload, 'UploadCard', 'GetTokenButton', 'Text'),
      submitButton: creator(UiSection.Upload, 'UploadCard', 'SubmitButton', 'Text'),
      uploadDetails: {
        idLabel: creator(UiSection.Upload, 'UploadCard', 'UploadDetails', 'IdLabel'),
      },
    },
    eventsCard: {
      title: creator(UiSection.Upload, 'EventsCard', 'Title'),
      getEventsButton: creator(UiSection.Upload, 'EventsCard', 'GetEventsButton', 'Text'),
    },
  },
  header: {
    userSelect: {
      userSelectLabel: creator(UiSection.Header, 'UserSelect', 'UseAs'),
      loadingText: creator(UiSection.Header, 'UserSelect', 'LoadingText'),
      unableToLoadText: creator(UiSection.Header, 'UserSelect', 'UnableToLoadText'),
      usersNotFound: creator(UiSection.Header, 'UserSelect', 'UsersNotFound'),
      orgPlaceholder: creator(UiSection.Header, 'UserSelect', 'OrgPlaceholder'),
      userPlaceholder: creator(UiSection.Header, 'UserSelect', 'UserPlaceholder'),
    },
  },
};
